<template>
  <div id="login">
    <v-container>
      <v-row>
        <v-col>
          <slot/>
        </v-col>
      </v-row>
      <v-row>
        <v-spacer/>
        <v-col cols="4">
          <v-img
              :src="require('@/assets/logo.png')"
              contain
              @click="$router.push('/')"
          />
        </v-col>
        <v-spacer/>
      </v-row>
      <v-row>
        <v-spacer/>
        <v-col :cols="$vuetify.breakpoint.mobile?12:5" class="pl-8">
          <v-form
              ref="form"
              v-model="valid"
              lazy-validation
          >
            <v-container>
              <v-row
                  justify="space-between"
              >
                <v-col class="pr-8">
                  <v-text-field
                      v-model="phone"
                      :counter="11"
                      :rules="phoneRules"
                      label="手机号码"
                      required
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="8">
                  <v-text-field
                      v-model="code"
                      :rules="codeRules"
                      :counter="4"
                      label="验证码"
                      required
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-btn
                      color="warning"
                      @click="sendCode"
                  >
                    发送验证码
                  </v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-btn
                      :disabled="!valid"
                      color="success"
                      @click="onLogin"
                  >
                    登陆
                  </v-btn>
                </v-col>
                <v-col align="end">
                  <v-btn
                      text
                      color="primary"
                      depressed
                      @click="$router.push('/')"
                  >
                    返回首页
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-col>
        <v-spacer/>
      </v-row>

    </v-container>

  </div>
</template>

<script>
import * as userApi from '@/servers/user'
import auth from '@/utils/auth'
import {mapMutations} from "vuex";

export default {
  name: 'Login',
  data: () => ({
    valid: true,
    phone: '',
    phoneRules: [
      v => !!v || '请填写手机号码',
      v => (v && v.length === 11) || '手机号码必须是11位',
    ],
    code: '',
    codeRules: [
      v => !!v || '短信验证码不能为空',
      v => (v && v.length === 4) || '短信验证码必须是4位',
    ],
  }),

  methods: {
    ...mapMutations(['setUserInfo']),
    sendCode() {
      userApi.sendVCode({telephone: this.phone});
    },
    onLogin() {
      this.$refs.form.validate()
      let redirectUrl = '/'
      if (
          this.$route.query &&
          this.$route.query != null &&
          this.$route.query.redirect &&
          this.$route.query.redirect != null
      ) {
        redirectUrl = this.$route.query.redirect
      }
      userApi.login({telephone: this.phone, vcode: this.code})
          .then(res => {
            console.info(res)
            auth.login(res.token)
            redirectUrl && this.$router.push({path: redirectUrl})
            this.setUserInfo(this.phone)
          });
    },
  },
  components: {},
}
</script>
